import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PortalModule } from '@angular/cdk/portal';
import { OverlayModule } from '@angular/cdk/overlay';
import { MatLegacyProgressBarModule as MatProgressBarModule } from '@angular/material/legacy-progress-bar';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { TcsLoadingComponent } from 'src/app/shared/components/loading/components/loading/loading.component';
import { TcsLoadingDirective } from 'src/app/shared/components/loading/loading.directive';
import { loadingFactoryProvider } from 'src/app/shared/components/loading/loading.factory';
import { loadingProvider } from 'src/app/shared/components/loading/loading.service';

const tcsLoading = [TcsLoadingComponent, TcsLoadingDirective];

@NgModule({
  imports: [
    CommonModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    OverlayModule,
    PortalModule,
  ],
  declarations: [tcsLoading],
  exports: [tcsLoading],
  providers: [loadingFactoryProvider, loadingProvider],
})
export class TcsLoadingModule {}
